/**
 * ヘッダータイトル
 */
export enum HeaderTitle {
  MarcketPlace = 'マーケットプレイス ',
  Cart = 'カート',
  MyPage = 'マイページ'
}

/**
 * プロダクト区分
 */
export enum ProductType {
  Software = '01',
  API = '02'
}

/**
 * ページ種別
 */
export enum PageCategory {
  MARKET_PLACE = 'MONETマーケットプレイス',
  MYPAGE = 'マイページ',
  ENTRY = 'アカウント登録',
  BLOG = 'ブログ'
}

/**
 * 支払い方法
 */
export enum PaymentMethod {
  CREDIT = 'credit',
  INVOICE = 'invoice'
}

export const UserInfoObjectPath = {
  AUTH_USER: 'monet-technologies.co.jp/account_name',
  EMAIL: 'email'
};

/**
 * 利用規約区分
 */
export enum TosType {
  None = 'なし',
  TEXT = 'テキスト',
  PDF = 'PDF'
}

/**
 * 料金プラン課金区分
 */
export enum ChargeType {
  ONE_TIME = 'OneTime',
  RECURRING = 'Recurring',
  USAGE = 'Usage'
}

/**
 * エラーコード
 */
export * from './ErrorCode';

/**
 * HTTPステータスコード
 */
export * from './HttpStatusCode';
